/* eslint-disable react/no-array-index-key */
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useStore } from '../../../stores/store';

import { ReactComponent as MoneyIcon } from '../../../assets/money.svg';
import InfoSelectWithSidebar from '../../../common/info-select-with-sidebar/info-select-with-sidebar.component';

import GenericInfoBlock from '../../../common/generic-info-block/generic-info-block.component';

const TaxesSidebar = () => {
  const {
    userStore: { user },
    parcelCreationStore: {
      getTaxesInfo,
      taxesInfo,
      isLoadingTaxes,
      navigation,
    },
  } = useStore();

  const { t } = useTranslation();

  const taxesElement = navigation.current?.elements.find(
    (el) => el.name === 'taxes'
  );
  const taxesLink = taxesElement?.content?.find(
    (content) => content.type === 'button' && !!content.link
  )?.link;

  const handleInputClick = () => {
    if (!taxesLink) return;
    window.open(taxesLink, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    // Omit obtaining taxes info if we have the direct link from navigation
    if (taxesLink) return;
    getTaxesInfo();
  }, [getTaxesInfo, user?.lang, taxesLink]);

  return (
    <InfoSelectWithSidebar
      onInputClick={handleInputClick}
      appearence='blue'
      icon={<MoneyIcon />}
      sidebarName='customs_and_duty'
      sidebarTitle={t('taxes_customs')}
      placeholder={t('taxes_customs')}
      disableSidebar={!!taxesLink}>
      {taxesInfo && (
        <GenericInfoBlock
          genericInfo={taxesInfo}
          mode='taxes'
          isLoading={isLoadingTaxes}
        />
      )}
    </InfoSelectWithSidebar>
  );
};

export default observer(TaxesSidebar);
